// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { solutionsStyles } from "@guestsupply/App/Widgets/Solutions/Solutions";
import { layoutContainer } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

solutionsStyles.container = {
    css: css`
        ${({ backgroundColor }: any) =>
            css`
                background: ${backgroundColor};
            `}
    `,
};

solutionsStyles.wrapper = {
    css: css`
        padding: 32px 0;
        ${layoutContainer}
    `,
};
